import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class CaseTypeCaseMode extends Resource {
    public override type = 'caseTypeCaseModes';

    @prop()
    public caseTypeId!: string;

    @prop()
    public caseModeId!: string;
}
